export default function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-hierarchy/src/hierarchy/ancestors.js
// module id = ../../../../d3-hierarchy/src/hierarchy/ancestors.js
// module chunks = 4